import { call, put, takeEvery } from "redux-saga/effects";
//actions
import {
  employeeSalaryDetailsSuccess,
  employeeSalaryDetailsFailure,
} from "../../../actions/Workforce/EmployeeDetils/SalaryDetails";
//constant
import { EMPLOYEE_SALARY_DETAILS } from "../../../constants/Workforce/EmployeeDetils/SalaryDetails";
//request type
import getRequest from "../../../../util/APIHelperGet";
import { baseUrl } from "../../../../util/APIBaseUrl";

export const fetchEmployeeSalaryDetailsRequest = async (actions) => {
  return await getRequest(`${baseUrl}/${actions.payload.request}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchEmployeeSalaryDetails(params) {
  try {
    let response = yield call(fetchEmployeeSalaryDetailsRequest, params);
    yield put(employeeSalaryDetailsSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(employeeSalaryDetailsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(EMPLOYEE_SALARY_DETAILS, fetchEmployeeSalaryDetails);
}
